import { ENewbuildingExtraPricesActions, TNewbuildingExtraPricesActions } from 'shared/actions/newbuildingExtraPrices';
import { IPurchaseTermsResponse } from 'shared/types/purchaseTerm/purchaseTermsV2';

const initialState: IPurchaseTermsResponse = {
  extraPrices: [],
  linkedPromos: [],
  mainPrice: undefined,
};

export const newbuildingExtraPricesReducer = (
  state: IPurchaseTermsResponse = initialState,
  action: TNewbuildingExtraPricesActions,
): IPurchaseTermsResponse => {
  switch (action.type) {
    case ENewbuildingExtraPricesActions.SetExtraPrices:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
